import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import ReviewsGrid from '@components/ReviewsGrid';
import {IReviewsItem} from '@common/types';
import Text from '@common/components/common/Text';

export const Reviews = () => {
  const {page, reviews} = useTypedSelector(state => state.reviews)

  return (
    <section className="feedback-content">
      <div className="container">
        <h1 className="feedback-content__title">
          <Text text={page?.title}/>
        </h1>
        {!!reviews?.length && (
          <ReviewsGrid
            type="reviews"
            reviews={reviews?.map((r) => ({
              title: r.description,
              description: r.companyName,
              customer: r.customer,
              color: r.color,
              cardType: r.cardType,
              preview: r?.preview
            })) as IReviewsItem[] || []}
          />
        )}
      </div>
    </section>
  )
}
